import {Component} from "@angular/core";
import {FUIAbstractValidation} from "../abstract-validation";

@Component({
    selector: "fui-mandatory-validation",
    styleUrls: ["mandatory-validation.component.scss"],
    templateUrl: "./mandatory-validation.component.html"
})
export class FUIMandatoryValidationComponent extends FUIAbstractValidation {

    override ngOnInit(): void {
        super.ngOnInit();
        this.valid = true;
    }
}
